<template>
  <div v-if="shouldShow" class="ad-banner-wrapper">
    <!-- 内层容器：宽度始终占满父容器，但限制最大标准尺寸 -->
    <div class="ad-inner" :class="innerClass">
      <!-- Google AdSense -->
      <ins
        v-if="useAdSense"
        class="adsbygoogle"
        style="display:block"
        :data-ad-client="clientId"
        :data-ad-slot="resolvedSlotId"
        :data-ad-format="type === 'banner' ? 'horizontal' : undefined"
        data-full-width-responsive="true"
      />
      <!-- 自定义占位（未配置 AdSense 时显示） -->
      <div v-else class="ad-placeholder">
        <span>{{ $t('ad') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdBanner',
  props: {
    page: {
      type: String,
      required: true
    },
    slotId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'billboard'
    }
  },
  computed: {
    isAllowedHost() {
      var allowedHosts = ['www.octosay.ai']
      return allowedHosts.indexOf(window.location.hostname) >= 0
    },
    webAdConfig() {
      var ad = this.$config.ad
      if (!ad || !ad.web) {
        return null
      }
      return ad.web
    },
    pageConfig() {
      var cfg = this.webAdConfig
      if (!cfg || !cfg.pages) {
        return null
      }
      return cfg.pages[this.page] || null
    },
    shouldShow() {
      // 非正式域名直接显示占位框（方便测试布局）
      if (!this.isAllowedHost) {
        return true
      }
      var cfg = this.pageConfig
      if (!cfg) {
        return false
      }
      return cfg.enabled === true || cfg.enabled === '1' || cfg.enabled === 1
    },
    clientId() {
      var cfg = this.webAdConfig
      return cfg ? (cfg.adsenseClientId || '') : ''
    },
    resolvedSlotId() {
      var propSlot = this.slotId || ''
      var cfg = this.pageConfig
      var pageSlot = cfg ? (cfg.slotId || '') : ''
      return propSlot.length > 0 ? propSlot : pageSlot
    },
    useAdSense() {
      return this.isAllowedHost && this.clientId.length > 0 && this.resolvedSlotId.length > 0
    },
    innerClass() {
      if (this.type === 'banner') {
        return 'ad-inner-banner'
      }
      if (this.type === 'billboard') {
        return 'ad-inner-billboard'
      }
      return 'ad-inner-mrec'
    }
  },
  mounted() {
    if (this.useAdSense && typeof window !== 'undefined' && window.adsbygoogle) {
      try {
        window.adsbygoogle.push({})
      } catch (e) {
        console.error('[AdBanner] adsbygoogle push error:', e)
      }
    }
  }
}
</script>

<style scoped>
.ad-banner-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding: 32px 0 8px;
}
.ad-inner {
  width: 100%;
}
.ad-inner-billboard {
  max-width: 970px;
  height: 250px;
}
.ad-inner-banner {
  max-width: 728px;
  height: 90px;
}
.ad-inner-mrec {
  max-width: 336px;
  height: 280px;
}
.ad-placeholder {
  width: 100%;
  height: 100%;
  background: #F7F5F2;
  border: 1px dashed #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bbb;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdBanner.vue